module.exports = __webpack_public_path__ + "static/undraw_mobile_apps-999ad761c8c7611713e50507e4067478.svg";